/** @jsxImportSource @emotion/react */
import React, { memo, useCallback } from 'react'
import { getUnimpersonationUrl } from '@signal/core/auth/auth'
import withCommonSnapshotsOnly from '@signal/hoc/withCommonSnapshotsOnly'
import renderIf from '@signal/utils/renderIf'
import { LockOpenOutlined, PersonOutline } from '@material-ui/icons'
import {
  UserNavMenuContainer,
  SelectedDealerText,
  UserIconWrapper,
  EmailText,
  StopImpersonateButton
} from './styles'
import { useDarkModeContext } from '@signal/theme/Context/dark-mode'
import TypographySkeleton from '@signal/components/Skeleton/Typography'

export type UserPreviewNewProps = {
  title: string
  email: string
  isImpersonating: boolean
  onClick: () => void
  isSkeleton?: boolean
}

const UserPreviewNew: React.FC<UserPreviewNewProps> = ({
  title,
  email,
  isImpersonating,
  onClick,
  isSkeleton
}) => {
  const { isDarkMode } = useDarkModeContext()
  const handleStopImpersonate: React.MouseEventHandler<HTMLButtonElement> =
    useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      e.stopPropagation()
      const url = getUnimpersonationUrl()
      window.location.replace(url)
    }, [])

  return (
    <UserNavMenuContainer onClick={onClick}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start'
        }}
      >
        <SelectedDealerText>
          {renderIf(
            !isSkeleton,
            () => title,
            () => (
              // @ts-ignore
              <TypographySkeleton variant="body1" width={200} />
            )
          )}
        </SelectedDealerText>
        <EmailText $isImpersonating={isImpersonating}>{email}</EmailText>
      </div>
      <UserIconWrapper
        $isImpersonating={isImpersonating}
        $isDarkMode={isDarkMode}
      >
        <PersonOutline />
        {renderIf(isImpersonating, () => (
          <StopImpersonateButton
            onClick={handleStopImpersonate}
            title="Stop impersonating"
            aria-label="Stop impersonating"
          >
            <LockOpenOutlined style={{ fontSize: '14px' }} />
          </StopImpersonateButton>
        ))}
      </UserIconWrapper>
    </UserNavMenuContainer>
  )
}

export default memo(withCommonSnapshotsOnly(UserPreviewNew))
